import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppWithoutAuth from './AppWithoutAuth';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createStore, compose } from 'redux';
import allReducer from './store/reducers';
import { Provider } from 'react-redux';
import Home from './pages/home';
import SurveyDetail from './pages/surveyDetail';
import HelpPage from './components/help';
import UserGuide from './components/help/userGuide';
import QRobot from './components/home/qRobot';
import CreateFromFile from './components/home/createFromFile';
import Benchmarked from './components/home/benchmarked';
import Summary from "./components/surveyDetail/summary";
import Design from "./components/surveyDetail/design";
import CollectOverview from "./components/surveyDetail/collectOverview";
import CollectRecipientList from "./components/surveyDetail/collectRecipientList";
import CollectImportRecipientList from "./components/surveyDetail/collectImportRecipientList";
import CollectImportFromSurvey from "./components/surveyDetail/collectImportFromSurvey";
import CollectEmailTemplate from "./components/surveyDetail/collectEmailTemplate";
import CollectSchedule from "./components/surveyDetail/collectSchedule";
import Results from "./components/surveyDetail/results";
import Insight from "./components/surveyDetail/insight";
import InsightSankey from "./components/surveyDetail/insightSankey";
import MainReport from './components/surveyDetail/mainReport';
import StrengthsWeaknesses from './components/surveyDetail/strengthsWeaknesses';
import GapAnalysis from './components/surveyDetail/gapAnalysis';
import BenchmarkedDescription from './components/surveyDetail/benchmarkedDescription';
import HeatMap from './components/surveyDetail/heatMap';
import Findings from './components/surveyDetail/findings';
import Recommendations from './components/surveyDetail/recommendations';
import UserSurvey from './pages/userSurvey';
import Page404 from './pages/404';
import QRobotProgress from './components/home/qRobotProgress';
import { Amplify } from 'aws-amplify';
import config from './aws-exports';
import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: "https://e0ddf74b7c2905901e38a0ba4ea54465@o4510402649325568.ingest.us.sentry.io/4510781839769600",
  tunnel: "https://0sbimzluq2.execute-api.us-east-1.amazonaws.com/test/tunnel",
  integrations: [
      // Automatically instrument React components
      Sentry.browserTracingIntegration(),
      // Capture console errors
      Sentry.captureConsoleIntegration({
        levels: ['error', 'warn']
      }),
      // Capture fetch/XHR requests
      Sentry.browserApiErrorsIntegration(),
      // Session replay (optional - records user sessions for debugging)
      Sentry.replayIntegration(),
    ],

  sendDefaultPii: true,
});


const composeEnhancers =
  process.env.REACT_APP_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : compose;

const store = createStore(
  allReducer,
  composeEnhancers()
);

Amplify.configure(config);

const root = ReactDOM.createRoot(document.getElementById('root'));
const currentPath = window.location.pathname;
const router = createBrowserRouter([
  {
    path: "/survey",
    element: <AppWithoutAuth />,
    children: [
      { path: ":user_survey_id/", element: <UserSurvey /> }
    ]
  },
  {
    path: "/*",
    element: <App />, // App.js artık root
    children: [
      { path: "", element: <Home /> },                // /
      {
        path: "home/*",
        element: <Home />,
        children: [
          { path: "q-robot/*", element: <QRobot /> },
          { path: "create-from-file", element: <CreateFromFile /> },
          { path: "benchmarked", element: <Benchmarked /> },
          { path: "qrobot-progress", element: <QRobotProgress /> }
        ]
      },
      {
        path: "surveys/:survey_id/*",
        element: <SurveyDetail />,
        children: [
          { path: "summary", element: <Summary className="overflow-y-hidden" /> },
          { path: "design", element: <Design /> },
          { path: "collect-overview", element: <CollectOverview /> },
          { path: "collect-recipient-list", element: <CollectRecipientList /> },
          { path: "collect-import-recipient-list", element: <CollectImportRecipientList /> },
          { path: "collect-import-from-survey", element: <CollectImportFromSurvey /> },
          { path: "collect-email-template", element: <CollectEmailTemplate /> },
          { path: "collect-schedule", element: <CollectSchedule /> },
          { path: "results", element: <Results /> },
          { path: "insight-summary", element: <Insight /> },
          { path: "insight-main-report", element: <MainReport /> },
          { path: "insight-sankey", element: <InsightSankey /> },
          { path: "insight-strengths-weaknesses", element: <StrengthsWeaknesses /> },
          { path: "insight-gap-analysis", element: <GapAnalysis /> },
          { path: "insight-benchmarked-description", element: <BenchmarkedDescription /> },
          { path: "insight-heatmap", element: <HeatMap /> },
          { path: "insight-findings", element: <Findings /> },
          { path: "insight-recommendations-roadmap", element: <Recommendations /> },
        ]
      },
      {
        path: "help/*",
        element: <HelpPage />,     // parent route
        children: [
          { path: "userGuide", element: <UserGuide /> }  // nested route
        ]
      },
      { path: "survey/:user_survey_id/", element: <UserSurvey /> },

      { path: "help/userGuide", element: <UserGuide /> },
      { path: "404", element: <Page404 /> },
    ],
  },




], {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
});

root.render(
  <Provider store={store}>
    <Sentry.ErrorBoundary>
      <RouterProvider router={router} />
    </Sentry.ErrorBoundary>
  </Provider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
